var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IperMatrizPeligrosSector"},[(_vm.sector)?_c('div',[_vm._v(_vm._s(_vm.sector))]):_c('div',[_c('i',{staticClass:"fas fa-minus"})])])}
var staticRenderFns = []

export { render, staticRenderFns }